import { SVGProps } from 'react';
const FeedbackIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
    >
        <path
            fillRule="evenodd"
            d="m10.628 6.678.206-.051a.06.06 0 0 0 .029-.016l4.017-4.054a.06.06 0 0 0 0-.085l-.875-.866a.06.06 0 0 0-.085 0L9.905 5.66a.06.06 0 0 0-.017.032l-.045.253-.009.052-.122.693-.023.133a.06.06 0 0 0 .073.07l.132-.033.682-.169.052-.012ZM9.265 5.025 13.281.973a.96.96 0 0 1 1.357-.006l.875.866a.96.96 0 0 1 .006 1.357l-4.017 4.054a.96.96 0 0 1-.452.257l-1.072.264a.96.96 0 0 1-1.176-1.099l.2-1.131a.96.96 0 0 1 .263-.51ZM2 3.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h5v1h-.002v1.8c0 .018.005.025.007.028a.055.055 0 0 0 .024.018.055.055 0 0 0 .03.005c.004-.001.012-.003.025-.015l.646-.647 1.754-1.754v-.001l.43-.436h.54v.002H14a.5.5 0 0 0 .5-.5V5.627a.502.502 0 1 1 1 0v5.372a1.5 1.5 0 0 1-1.5 1.5h-3.547v.001h-.262l-1.824 1.824-.647.647c-.598.598-1.622.175-1.622-.672v-1.8H2A1.5 1.5 0 0 1 .5 11V4A1.5 1.5 0 0 1 2 2.5h7.25a.502.502 0 1 1 0 1H2ZM3.5 5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM3 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM3.5 9a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z"
            clipRule="evenodd"
        />
    </svg>
);
export default FeedbackIcon;
